export const recentactivty =[
   {
      id:1, 
      date:"20-04-2023",
      day:"Today",
      title:"Updated Product",
      subtitle:"I like to be real. I don't like things to be staged or fussy.",
      className:"activity-dot-secondary",
      circleicon:"circle-dot-secondary"

   },
   {
      id:2,
      date:"20-04-2023",
      day:"Today",
      title:"James just like your product",
      subtitle:"Design and style should work toward making look good..",
      newbadges:"New",
      badgeName: <span className="badge badge-primary ms-2">New</span>,
      className:"activity-dot-primary",
      circleicon:" circle-dot-primary ",
      img:"shoes1.png",
      img2:"shoes2.png"

   },
   {
      id:3,
      date:"20-04-2023",
      day:"Today",
      title:"Jihan Doe just like your product",
      subtitle:"If you have it, you can make anything look good..",
      className:"activity-dot-secondary",
      circleicon:"circle-dot-secondary"
   },
]